import { render, staticRenderFns } from "./ExportacaoGridParaExcel.vue?vue&type=template&id=14d0b700&scoped=true"
import script from "./ExportacaoGridParaExcel.vue?vue&type=script&lang=js"
export * from "./ExportacaoGridParaExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0b700",
  null
  
)

export default component.exports